export default {
      id: "wedding-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#wedding",
      toString: function () {
        return this.url;
      }
    }